import { estabelecimento } from "../Estabelecimento/estabelecimento"
import { format, newPage, sentryError } from "../utils"
import template from "./sobre.hbs"

export const Sobre = () => {

    mixpanel.track("Abriu a página sobre", { "Estabelecimento": estabelecimento.fantasia });

    newPage({
        appbarTitle: 'Informações', id: 'sobre'
    })

    const descricao = estabelecimento.informarcao ? estabelecimento.informarcao : ''
    const email = estabelecimento.contato.email ? estabelecimento.contato.email : '#'
    const twitter = estabelecimento.contato.twitter ? estabelecimento.contato.twitter : '#'
    const facebook = estabelecimento.contato.facebook ? estabelecimento.contato.facebook : '#'
    const site = estabelecimento.contato.site ? estabelecimento.contato.site : '#'
    const instagram = estabelecimento.contato.instagram ? estabelecimento.contato.instagram : '#'
    const telefone = estabelecimento.contato.telefone ? estabelecimento.contato.telefone : '#'
    const logradouro = estabelecimento.endereco.logradouro ? estabelecimento.endereco.logradouro : ''
    const numero = estabelecimento.endereco.numero ? estabelecimento.endereco.numero : ''
    const bairro = estabelecimento.endereco.bairro ? estabelecimento.endereco.bairro : ''
    const cidade = estabelecimento.endereco.cidade ? estabelecimento.endereco.cidade : ''
    const estado = estabelecimento.endereco.estado ? estabelecimento.endereco.estado : ''
    const pedidominimo = estabelecimento.valorMinimoPedido ? format.money(estabelecimento.valorMinimoPedido) : ''
    const diadasemana = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado']
    const horarios = []
    const freeDeliveryTax = estabelecimento.entregaGratis ?  format.money(estabelecimento.entregaGratis) : ''

    estabelecimento.diasDelivery.forEach(dia => {
        const intervalos = []
        if (dia.Intervalos && dia.Intervalos.length > 0) {
            dia.Intervalos.forEach(intervalo => {
                intervalos.push(intervalo.StartTime.slice(0, 5))
                intervalos.push(intervalo.EndTime.slice(0, 5))
            })
            horarios.push({
                dia: diadasemana[dia.DiaDaSemana],
                intervalos: intervalos,
                hoje: dia.DiaDaSemana == (new Date().getDay()) ? true : false
            })
        }
    })

    const bandeiras = {
        Visa: '/images/web/cartoes/visa.svg',
        Mastercard: '/images/web/cartoes/mastercard.svg',
        American_Express: '/images/web/cartoes/amex.svg',
        Sorocred: '/images/web/cartoes/sorocred.svg',
        Diners_Club: '/images/web/cartoes/dinersclub.svg',
        Elo: '/images/web/cartoes/elo.svg',
        Hipercard: '/images/web/cartoes/hypercard.svg',
        Aura: '/images/web/cartoes/aura.svg',
        Cabal: '/images/web/cartoes/cabal.svg',
        Outros: '/images/web/cartoes/outros.svg'
    }

    const metodosPagamento = []
    if (estabelecimento.pagamento && estabelecimento.pagamento.metodos) {
        estabelecimento.pagamento.metodos.forEach(item => {
            if (item.Prefixo == "DIN") {
                metodosPagamento.push({
                    tipo: "Dinheiro", Dinheiro: true
                })
            } else {
                if (item.Prefixo == "CRDE" || item.Prefixo == "CRCR") {

                    const metodo = {
                        tipo: item.Prefixo == "CRDE" ? "Cartão de Débito" : "Cartão de Crédito",
                        bandeiras: []
                    }

                    item.Bandeiras.forEach(bandeira => {
                        metodo.bandeiras.push({
                            descricao: bandeira.Bandeira.Descricao,
                            imagem: bandeiras[bandeira.Bandeira.StrTipoBandeira]
                        })
                    })

                    metodosPagamento.push(metodo)

                }

            }
        })
    }

    select('.page-body').innerHTML = template({
        descricao, email, twitter, facebook, site, telefone, instagram,
        logradouro, numero, bairro, cidade, estado, horarios, metodosPagamento,
        pedidominimo, freeDeliveryTax
    })

    const tabs = selectAll(".scroll-snap-x nav a")
    tabs && tabs.forEach(tab => {
        tab.addEventListener('click', () => {

            const ativo = select('.scroll-snap-x nav a[active]')
            ativo && ativo.removeAttribute('active')

            tab.setAttribute('active', '')
        })
    })

    const sobre = select('#sobre');
    sobre && sobre.addEventListener("scroll", (e) => { console.log(e) });

    sobre.querySelector('.app-bar img').addEventListener('click', () => {
        clearInterval(interval)
    })

    const interval = setInterval(() => {
        const breakPoint = window.innerWidth / 2
        const paginas = selectAll('.scroll-snap-x article')
        paginas.forEach(pagina => {
            const x = pagina.getBoundingClientRect().x
            if (x < breakPoint && x >= 0) {
                const paginaSelecionada = select('[href="#' + pagina.id + '"]');
                const ativo = select('.scroll-snap-x nav a[active]')

                if (paginaSelecionada != ativo) {
                    ativo && ativo.removeAttribute('active')
                    paginaSelecionada.setAttribute('active', '')
                }

            }
        })
    }, 500);
}